<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "InformasiArticle",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
